import { adminService } from '@/api/services';

import type { IEnrolledSectionParticipantsResponse, EEnrolledSectionParticipantStatus } from './types';

export const enrolledParticipantsService = adminService.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Получить список зачисленных участников
     */
    getEnrolledSectionParticipants: builder.query<
      IEnrolledSectionParticipantsResponse,
      {
        schoolId: number;
        page?: number;
        perPage?: number;
        statusFilter?: EEnrolledSectionParticipantStatus[] | null;
      }
    >({
      query: ({ schoolId, page, perPage, statusFilter }) => ({
        method: 'GET',
        url: `/schools/${schoolId}/enrolled_students`,
        params: {
          page,
          per_page: perPage,
          q: {
            status_in: statusFilter,
          },
        },
      }),
      providesTags: (_, __, { schoolId }) => [{ type: 'SchoolEnrolledParticipants', id: schoolId }],
    }),
    /**
     * Отчислить студента
     */
    expelEnrolledSectionParticipant: builder.mutation<
      void,
      {
        schoolId: number;
        participantId: number;
        expulsionReason: string;
        expelledAt: string;
      }
    >({
      query: ({ schoolId, participantId, expulsionReason, expelledAt }) => ({
        method: 'POST',
        url: `/schools/${schoolId}/enrolled_students/${participantId}/expel`,
        body: {
          data: {
            expulsion_reason: expulsionReason,
            expelled_at: expelledAt,
          },
        },
      }),
      invalidatesTags: (_, __, { schoolId }) => [{ type: 'SchoolEnrolledParticipants', id: schoolId }],
    }),
  }),
});

export const { useGetEnrolledSectionParticipantsQuery, useExpelEnrolledSectionParticipantMutation } =
  enrolledParticipantsService;
